export const CIVILITES = [
  { value: 'M.', label: 'M.' },
  { value: 'Mme', label: 'Mme' },
];

export const formatNom = (v) => (v || '').toUpperCase();

export const formatPrenom = (v) =>
  (v || '')
    .toLowerCase()
    .split(' ')
    .map((w) => w.split('-').map((s) => (s ? s[0].toUpperCase() + s.slice(1) : s)).join('-'))
    .join(' ');

const cmp = (a, b) => (a || '').localeCompare(b || '', 'fr', { sensitivity: 'base' });

export const sortPersonnes = (list, getPersonne = (x) => x) =>
  [...(list || [])].sort((x, y) => {
    const a = getPersonne(x) || {};
    const b = getPersonne(y) || {};
    return cmp(a.nom, b.nom) || cmp(a.prenom, b.prenom);
  });
